import { jsx, Fragment } from 'react/jsx-runtime';
import { useState, useCallback, useEffect } from 'react';
import { DelayedContentContextProvider, useDelayedContentContext } from './context.mjs';
import { useTimeout } from './useTimeout.mjs';

const DelayedContent = ({
  children,
  delayTime = 200,
  minDisplayTime
}) => {
  const [isShow, setIsShow] = useState(delayTime === 0);
  const { setTimeout } = useTimeout();
  const handleStartLoading = useCallback(() => {
    setIsShow(true);
    if (minDisplayTime) {
      setTimeout(() => {
        setIsShow(false);
      }, minDisplayTime);
    }
  }, [minDisplayTime, setTimeout]);
  return /* @__PURE__ */ jsx(
    DelayedContentContextProvider,
    {
      delayTime,
      isShow,
      onStartLoading: handleStartLoading,
      children
    }
  );
};
const Delay = ({ children }) => {
  const { delayTime, onStartLoading } = useDelayedContentContext();
  const [showLoading, setShowLoading] = useState(delayTime === 0);
  const { setTimeout } = useTimeout();
  useEffect(() => {
    setTimeout(() => {
      setShowLoading(true);
      onStartLoading();
    }, delayTime);
  }, [delayTime, onStartLoading, setTimeout]);
  return showLoading ? /* @__PURE__ */ jsx(Fragment, { children }) : null;
};
const useDelayedContent = () => {
  const { isShow } = useDelayedContentContext();
  return {
    isShow
  };
};
DelayedContent.Delay = Delay;

export { DelayedContent, useDelayedContent };
//# sourceMappingURL=DelayedContent.mjs.map
